<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="uxmYh5RaWCnLLxdxOUujiZE">
<div class="_idGenObjectLayout-1">
<div id="uOeP4mX3NaN5lEIRgCxkVuE">
<img alt="" class="_idGenObjectAttribute-1" src="image/Chapter02_Image01.png"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stsebastianepub_split2.vue?24420b06